module.exports = "/assets/b0376ba4cab1eb2c4c3494f584179097.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/v2-icons/cross.svg
// module id = 71
// module chunks = 0